import { Field } from 'formik';
import { forwardRef, InputHTMLAttributes } from 'react';

export const CheckboxField = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({ className = '', ...props }, ref) => {
  return <Field type="checkbox" ref={ref} className="tribute-check-box" {...props} />;
});
